import { create } from 'zustand';

interface AvatarState {
  avatarChanged: boolean;
  setAvatarChanged: (changed: boolean) => void;
}

const useAvatarStore = create<AvatarState>((set) => ({
  avatarChanged: false,
  setAvatarChanged: (changed) => set({ avatarChanged: changed }),
}));

export default useAvatarStore;
